/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeactivateJiraCloudInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deactivateJiraCloudMutationVariables = {|
  input: DeactivateJiraCloudInput
|};
export type deactivateJiraCloudMutationResponse = {|
  +deactivateJiraCloud: ?{|
    +viewer: ?{|
      +company: ?{|
        +jiraVerificationKey: ?string,
        +jiraInstallationLinked: ?boolean,
      |}
    |}
  |}
|};
export type deactivateJiraCloudMutation = {|
  variables: deactivateJiraCloudMutationVariables,
  response: deactivateJiraCloudMutationResponse,
|};
*/


/*
mutation deactivateJiraCloudMutation(
  $input: DeactivateJiraCloudInput!
) {
  deactivateJiraCloud(input: $input) {
    viewer {
      company {
        jiraVerificationKey
        jiraInstallationLinked
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeactivateJiraCloudInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraVerificationKey",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraInstallationLinked",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deactivateJiraCloudMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateJiraCloudPayload",
        "kind": "LinkedField",
        "name": "deactivateJiraCloud",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deactivateJiraCloudMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateJiraCloudPayload",
        "kind": "LinkedField",
        "name": "deactivateJiraCloud",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deactivateJiraCloudMutation",
    "operationKind": "mutation",
    "text": "mutation deactivateJiraCloudMutation(\n  $input: DeactivateJiraCloudInput!\n) {\n  deactivateJiraCloud(input: $input) {\n    viewer {\n      company {\n        jiraVerificationKey\n        jiraInstallationLinked\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1424fe6457af4688979ada331271949a';

module.exports = node;
